import api from './api';

export const createSignupOrder = async () => {
    try {
        const response = await api.post('/payment/create-order-signup');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const verifySignupPayment = async (paymentData) => {
    try {
        const response = await api.post('/payment/verify-signup', paymentData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const getSignupPrice = async () => {
    try {
        const response = await api.get('/payment/signup-price');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const syncPaymentStatus = async (orderId) => {
    try {
        const response = await api.get(`/payment/sync-status/${orderId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
